import React, { RefObject, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  SCBottomBarContainer,
  SCButtonWrapper,
  SCButtonCircle,
  SCButtonLabel,
  SCButtonsRow,
  SCButtonIcon,
  SCInnerCircle
} from 'components/AugmentedReality/Photo/BottomBar/styled'
import useCamera from 'components/AugmentedReality/hooks/useCamera'

interface BottomBarProps {
  currentOverlay: string;
  onPrevious: () => void;
  camera: ReturnType<typeof useCamera>;
  videoRef: RefObject<HTMLVideoElement | null>;
  onPhotoTaken: (photo: string, overlay: string) => void;
  useRotate: boolean
}

const BottomBar = ({ currentOverlay, onPrevious, camera, videoRef, onPhotoTaken, useRotate }: BottomBarProps) => {
  const { t } = useTranslation()
  const [animateBack, setAnimateBack] = useState(false)
  const [animateCapture, setAnimateCapture] = useState(false)
  const [animateRotation, setAnimateRotation] = useState(false);

  const triggerAnimate = (setter: (v: boolean) => void) => {
    setter(true)
    setTimeout(() => setter(false), 750)
  }

  const handleCapture = async () => {
    const photo = await camera.capturePhoto(videoRef.current);
    if (photo) {
      onPhotoTaken(photo, currentOverlay);
    }
  };

  return (
    <SCBottomBarContainer>
      <SCButtonsRow>
        <SCButtonWrapper
          onClick={() => {
            triggerAnimate(setAnimateBack)
            onPrevious()
          }}
        >
          <SCButtonCircle $size="large" className={animateBack ? 'animate' : ''}>
            <SCButtonIcon src={'/static/ra/back.svg'} alt="Retour" />
          </SCButtonCircle>
          <SCButtonLabel>{t('augmentedReality.back')}</SCButtonLabel>
        </SCButtonWrapper>

        <SCButtonWrapper
          onClick={() => {
            triggerAnimate(setAnimateCapture)
            handleCapture()
          }}
        >
          <SCButtonCircle $size="xlarge" className={animateCapture ? 'animate' : ''}>
            <SCInnerCircle />
          </SCButtonCircle>
          <SCButtonLabel>{t('augmentedReality.photo.capture')}</SCButtonLabel>
        </SCButtonWrapper>

        {useRotate ? (
          <SCButtonWrapper
            onClick={() => {
              triggerAnimate(setAnimateRotation)
              camera.switchCamera()
            }}
          >
            <SCButtonCircle $size="large" className={animateRotation ? 'animate' : ''}>
              <SCButtonIcon src={'/static/ra/switch-camera.svg'} alt="Tourner la caméra" />
            </SCButtonCircle>
            <SCButtonLabel>{t('augmentedReality.calibrate.rotateCamera')}</SCButtonLabel>
          </SCButtonWrapper>
        ) : (
          <div style={{ width: '50px' }} />
        )}
      </SCButtonsRow>
    </SCBottomBarContainer>
  )
}

export default BottomBar